import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconFlag: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
            <path
                d="M5.99994 21C5.44765 21 4.99994 20.5523 4.99994 20V5C4.99994 4.44772 5.44765 4 5.99994 4H12.4927C12.973 4 13.3854 4.34148 13.4751 4.81334L13.7955 6.5H18.9999C19.5522 6.5 19.9999 6.94772 19.9999 7.5V14C19.9999 14.5523 19.5522 15 18.9999 15H12.5683C12.0923 15 11.6822 14.6644 11.5881 14.1978L11.2455 12.5H6.99994V20C6.99994 20.5523 6.55222 21 5.99994 21ZM12.9955 13H17.9999V8.5H13.3338C12.86 8.5 12.4513 8.16763 12.3548 7.70387L11.9999 6H6.99994V10.5H11.6787C12.156 10.5 12.5668 10.8373 12.6596 11.3055L12.9955 13Z"
                fill="#333333"
            />
        </svg>
    </Icon>
);
